export default {
  props: {
    comData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    attentionTitle() {
      return this.comData.attentionTitle;
    },
    attentionMsg() {
      return this.comData.attentionMsg 
        && this.comData.attentionMsg.replace(/\n/g, '<br>')
        || '';
    }
  }
}